module.exports = __webpack_public_path__ + "static/media/appointment_slider_phone1-1.71af2512.png";